<template>
  <div>
    <v-list-item
      v-if="showOrder"
      three-line
    >
      <v-list-item-avatar class="order-preview">
        <v-img
            v-if="order.photo"
            :src="order.photo.preview"
        ></v-img>
        <v-img
            v-else-if="order.wallPosts && order.wallPosts.attachments[0]"
            :src="order.wallPosts.attachments[0].data.preview"
        ></v-img>
        <v-img
            v-else-if="order.preview"
            :src="order.preview"
        ></v-img>
        <v-icon
            v-else
            class="primary--text"
        >
          {{getTypeLocalized.icon}}
        </v-icon>
        <v-icon
            v-if="!order.verified"
            class="accent--text blink not-verified"
        >
          mdi-cart
        </v-icon>
      </v-list-item-avatar>

      <v-list-item-content>
        <v-list-item-title class="order-title">
          {{order.title}}<span v-if="!order.verified">, ожидает проверки</span>
        </v-list-item-title>
        <v-list-item-subtitle>
          {{order.count}} x {{amountByOne | number}} {{ccy}} =
          <b>
            {{order.total | number}} {{ccy}}
            <a v-if="orderHasDescribe"
               class="primary--text"
               @click="fullDescribe = !fullDescribe"> (подробнее)</a>
          </b>
        </v-list-item-subtitle>
        <v-list-item-subtitle class="order-info">
          <OrderStockIndicator
              :order="order"
              :sourceStatuses="sourceStatuses"
              :buyout="buyout"
          ></OrderStockIndicator>
          <OrderTags
              v-if="order.tagIds"
              :order="order"
          ></OrderTags>
          <div v-if="fullDescribe">
            <span>{{order.totalDescribe}}</span>
          </div>
          <div>
            <span v-if="order.size">размер: {{order.size}}</span>
            <br v-if="order.size && order.color"/>
            <span v-if="order.color">цвет: {{order.color}}</span>
          </div>
        </v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-action v-if="hasProductLink">
        <v-btn
            color="accent"
            icon
            @click="openProduct"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </div>
</template>

<script>
import OrderStockIndicator from '@/components/OrderStockIndicator'
import OrderTags from './OrderTags.vue'
import {types} from '@/constants'
import {enableRefresh, windowOpen} from '@/services/vkApi'

export default {
  name: 'InvoiceListItemInfoOrder',
  components: {OrderStockIndicator, OrderTags},
  beforeDestroy () {
    enableRefresh()
  },
  created () {
    enableRefresh(false)
  },
  computed: {
    amountByOne () {
      return (this.order.total.toFixed(2) / this.order.count).toFixed(2);
    },
    hasProductLink () {
      return !this.order.fromStore && (this.order.photo && this.order.photo.url || this.order.wallPosts?.url)
    },
    getTypeLocalized () {
      return types.orders[this.order.type]
    },
    orderHasDescribe () {
      return this.order.type === types.orders.item.id && this.order.totalDescribe && !this.order.fullDescribe
    },
    showOrder () {
      return this.order.type === types.orders.item.id || types.orders.discount.id
          || this.order.type === types.orders.delivery.id || this.order.totalDescribe;
    }
  },
  data () {
    return {
      fullDescribe: false
    }
  },
  methods: {
    openProduct () {
      windowOpen(this.order.photo?.url ?? this.order.wallPosts?.url)
    }
  },
  props: {
    ccy: {
      required: true,
      type: String
    },
    order: {
      required: true,
      type: Object
    },
    sourceStatuses: {
      type: Object
    },
    buyout: {
      type: Object
    }
  }
}
</script>

<style scoped>
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.blink {
  animation: blinker 1s linear infinite
}
.not-verified {
  position: absolute;
  font-size: 16px;
  height: 16px;
  width: 16px;
  left: 31px;
  top: -4px;
}
.order-info {
  display: block;
}
.order-preview {
  overflow: visible;
}
.order-title {
  white-space: initial;
}
</style>